class TableFilter {
  component = undefined;
  initialState = undefined;
  values = undefined;
  constructor(component, initialState = undefined) {
    this.component = component;
    this.initialState = initialState;
    if (initialState !== undefined) this.values = initialState.defaultValues;
  }
}

class InitialState {
  defaultValues = [];
  applyOnInit = false;
  constructor(defaultValues = undefined, applyOnInit = false) {
    this.defaultValues = defaultValues;
    this.applyOnInit = applyOnInit;
  }
}

export { TableFilter, InitialState };
